import { useTranslation } from 'react-i18next';
import {
  CustomerComplianceDocument,
  customersApi,
} from '@texas/api/endpoints/customersApi';
import { VerifyDialogWithRequest } from '@texas/components/shared/dialog/VerifyDialogWithRequest';
import { SharedDisclosureProps } from '@texas/components/shared/types';
import { customerComplianceDocumentEvents } from './events';

interface Props extends SharedDisclosureProps {
  customerId: number;
  customerName: string;
  document: CustomerComplianceDocument;
}

export function RemoveCustomerComplianceDocument({
  customerId,
  customerName,
  document,
  isOpen,
  onClose,
}: Props) {
  const { t } = useTranslation();
  return (
    <VerifyDialogWithRequest
      headerTitle={t('customerComplianceDocuments.removeTitle')}
      secondaryButtonTitle={t('general.cancel')}
      primaryButtonTitle={t('general.remove')}
      primaryRequest={customersApi.removeComplianceDocument}
      args={[customerId, document.complianceDocumentDefinitionId]}
      isOpen={isOpen}
      onClose={onClose}
      onPerformed={() =>
        customerComplianceDocumentEvents.changed.dispatch(customerId)
      }
      onSuccessTitle={t('general.removed')}
    >
      {t('customerComplianceDocuments.removeConfirmation', {
        definition: document.name,
        name: customerName,
      })}
    </VerifyDialogWithRequest>
  );
}
